import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { showAccessDeniedModal, showSessionExpiredModal } from "../slices/authSlice";
const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  },
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {

    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const Uploadstream = createApi({
  reducerPath: "uploadstreamApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["uploadstream"],
  endpoints: (builder) => ({
    Uploadfiles: builder.mutation({
      query: ({ token, payload }) => {
        return {
          url: `/upload_file`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["uploadstream"],
    }),
    FetchUploadedFiles: builder.query({
      query: ({
        upload_type,
        start_date,
        token,
        end_date,
        category,
        taxonomy,
        page,
        n_records,
      }) => {
        return {
          url: `/list_of_uploaded_files`,
          method: "GET",
          params: {
            upload_type,
            start_date,
            end_date,
            category,
            taxonomy,
            page,
            n_records,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["uploadstream"],
    }),
    GenerateDocumentURL: builder.mutation({
      query: ({ token, file_name }) => {
        return {
          url: `/generate_document_url`,
          method: "POST",
          body: { file_name },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    DeleteUploadedFile: builder.mutation({
      query: ({ token, id, file_name }) => {
        return {
          url: `/delete_uploaded_file/${id}/${file_name}`,
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["uploadstream"],
    }),
  }),
});

export const {
  useUploadfilesMutation,
  useFetchUploadedFilesQuery,
  useGenerateDocumentURLMutation,
  useDeleteUploadedFileMutation,
} = Uploadstream;
